export default __webpack_public_path__ + "static/media/strategie-positionnement.fb1cb0db.svg";